import { z } from 'zod'
import { decimalSchema } from '../../utils/schema'

/**
 * アカウント情報のレスポンススキーマ
 * Aster API: GET /api/v1/account
 */
export const accountInfoSchema = z.object({
  feeTier: z.number(),
  canTrade: z.boolean(),
  canDeposit: z.boolean(),
  canWithdraw: z.boolean(),
  canBurnAsset: z.boolean(),
  updateTime: z.number(),
  balances: z.array(
    z.object({
      asset: z.string(),
      free: decimalSchema,
      locked: decimalSchema,
    }),
  ),
})
